var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

require('moment');
// require('bootstrap-five');
// import * as Popper from "@popperjs/core"
// require('bootstrap-five/js/dist/alert');
// require('bootstrap-five/js/dist/button');
// require('bootstrap-five/js/dist/carousel');
// require('bootstrap-five/js/dist/util');
// require('bootstrap-five/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
// require('bootstrap-five/js/dist/modal');
// require('bootstrap-five/js/dist/popover');
// require('bootstrap-five/js/dist/scrollspy');
require('bootstrap-five/js/dist/tab');
// require('bootstrap-five/js/dist/tooltip');

import Swiper from 'swiper/bundle';

// import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
// import bodymovin from 'lottie-web';
require('jquery-countdown');
require('mmenu-js');

// require('bootstrap-select');
// require('pc-bootstrap4-datetimepicker');
// require('bootstrap-datepicker');

// require('magnific-popup');

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function() {

    $(window).on('resize load scroll', function() {
    // var headerHeight = $('.navbar--main').outerHeight();
        var scroll = $(window).scrollTop();

        if (scroll >= 250 ) {  //scroll top menu out of view
            $('.navbar--main').addClass("down");
        } else {
            $('.navbar--main').removeClass("down");
        }
    });


    if ($('#clock').length) {
        $('#clock').countdown('2026/10/11', function(event) {
            $(this).html(event.strftime('' +
                '<div class="box"><h3>%D</h3><p>Days</p></div><div class="box"><h3>%H</h3><p>Hrs</p></div><div class="box"><h3>%M</h3><p>Mins</p></div><div class="box"><h3>%S</h3><p>Secs</p></div>'
            ));
        });
    }

    $('#btn-menu').on('click', function() {
        $(this).toggleClass('open');
        $('.sidebar-offcanvas').toggleClass('active');
    });


    // init Swiper:
        const sponsortSwiper = new Swiper('.sponsorCarousel', {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            observer: true,
            observeParents: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                dynamicBullets: true,
            },
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 320px
                480: {
                    slidesPerView: 2,
                },
                // when window width is >= 480px
                768: {
                    slidesPerView: 3,
                },
                // when window width is >= 640px
                1024: {
                    slidesPerView: 4,
                },

            },
        });


    const keydateSwiper = new Swiper('.keydateCarousel', {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            observer: true,
            observeParents: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                dynamicBullets: true,
            },
            // Responsive breakpoints
            breakpoints: {
                480: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },

            },
        });

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }

});


//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {

    // Infinite Ajax Scroll
}


document.addEventListener(
"DOMContentLoaded", () => {
    const menu = new Mmenu( "#mob-menu", {

        "extensions": [
            "position-front", "position-left"
        ]
    });
    const api = menu.API;

        document.querySelector( "#close-button" )
        .addEventListener(
            "click", () => {
                api.close();
            }
        );

    }
);
